import React from 'react';
import Aux from '../../../../hoc/_Aux';

const Triangle = (props) => {

    let globalSVGStyle = {};
    if(typeof props.color !=='undefined'){
        globalSVGStyle.fill = props.color;
    }

    if(typeof props.rotateAngle!== 'undefined'){
        globalSVGStyle = Object.assign({transform: 'rotate('+props.rotateAngle+'deg)'},globalSVGStyle);
    }

    return(
        <Aux>
            <svg id="triangle-shape" xmlns="http://www.w3.org/2000/svg" viewBox="20 30 110 100" style={globalSVGStyle}>
                <g>
                    <path d="M6.8,120.082,89.51,73.6l-1.025,95.014Z" transform="matrix(0.788, 0.616, -0.616, 0.788, 98.451, -62.184)"/>
                </g>
            </svg>
        </Aux>
    );
}

export default Triangle;


// WEBPACK FOOTER //
// ./src/containers/UI/Common/Shapes/Triangle.js